import React from 'react'
import SadasyaSikshya1 from '../../Images/SocialService/SadashyaSikshya/1.jpg'

const SocioServiceAll = () => {

    const socialserviceList = [
        {
            serviceID: '1',
            serviceName: 'सदस्य शिक्षा',
            SImage: SadasyaSikshya1,
            path: '/socialservice/sadashya-sikshya'
        },
    ]

    return (
        <>
            <div className='branches-div'>
                <div className='branches-top'>
                    <div className='welcome-title-center'>
                        <h2><span>शिक्षा / तालिम तथा सामाजिक सेवा</span></h2>
                    </div>
                </div>
                <div className='branches-body'>
                    <div className='card-container'>
                        {socialserviceList.map((item, id) => {
                            return (
                                <a href={item.path} onClick={() => { window.scrollTo({ top: 0 }) }}>
                                    <div className='card' key={id} style={{ width: '300px' }}>
                                        <div className='inner'>
                                            <div className='img-holder'>
                                                <img src={item.SImage} alt='service-Image' />
                                            </div>
                                            <div className='detail'>
                                                <h3>{item.serviceName}</h3>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            )
                        })}
                    </div>
                </div>
            </div>
        </>
    )
}

export default SocioServiceAll